import React, { useContext, useEffect } from 'react'; //eslint-disable-line
import { observer } from 'mobx-react-lite';
import locationStoreContext from '../stores/locationStore';
import viewStoreContext from '../stores/viewStore';
import BusStationHeader from './StationHeader';
import goTrackerConfig from 'goTrackerConfig';
import utils from '../utils';
import * as CONSTS from '../utils/constants';
import '../i18n';
import HeaderColumns from './HeaderColumns';
import BusStopRows from './BusStopRows';

const BusDetail = observer(props => {
  const locationStore = useContext(locationStoreContext);
  const viewStore = useContext(viewStoreContext);

  const loadPage = () => {
    const { corridor, station, tripNumber } = props.params;
    if (utils.isNullOrEmpty(corridor) || utils.isNullOrEmpty(station) || utils.isNullOrEmpty(tripNumber)) return;
    locationStore.busTripNumber = tripNumber;
    locationStore.loadBusTrip(tripNumber);
  };

  useEffect(() => {
    viewStore.updateView(CONSTS.VIEW_PATHS.TRIP_DETAIL);
  }, []);

  useEffect(() => {
    loadPage();

    const interval = setInterval(() => {
      locationStore.loadBusTrip(locationStore.busTripNumber);
      if (goTrackerConfig.debug) {
        viewStore.updateAutoRefreshTime();
      }
    }, goTrackerConfig.autoRefreshRate || 10000);
    return () => clearInterval(interval);
  }, [locationStore.corridors]);

  //Refactor
  const headerCol = props.headerCol;

  return (
    <main id="main-content">
      <div className="selection">
        <BusStationHeader stationName={locationStore.busTripDetail?.destination} isBus={true} />
        <HeaderColumns className="bus-departure-header-row trip" headerCol={headerCol} />
        {locationStore.isBusTripLoaded || locationStore.busTripDetail ? (
          <BusStopRows detail={locationStore.busTripDetail} isTwentyFourHour={viewStore.isTwentyFourHour}/>
        ) : (
          <ul>
            <li className="bus-departure-row no-trip">
              <i className="fa fa-spinner fa-spin" />
            </li>
          </ul>
        )}
      </div>
    </main>
  );
});

export default BusDetail;
